// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: candle-data-depot-option-chain.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Security } from "./candle-data-depot-common";
import { Expiry, OptionGreeks, TimeBucket } from "./common";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.candledatadepot.optionchain";

export enum Outlook {
  OUTLOOK_UNKNOWN = 0,
  LONG_BUILDUP = 1,
  LONG_UNWINDING = 2,
  SHORT_BUILDUP = 3,
  SHORT_COVERING = 4,
  UNRECOGNIZED = -1,
}

export function outlookFromJSON(object: any): Outlook {
  switch (object) {
    case 0:
    case "OUTLOOK_UNKNOWN":
      return Outlook.OUTLOOK_UNKNOWN;
    case 1:
    case "LONG_BUILDUP":
      return Outlook.LONG_BUILDUP;
    case 2:
    case "LONG_UNWINDING":
      return Outlook.LONG_UNWINDING;
    case 3:
    case "SHORT_BUILDUP":
      return Outlook.SHORT_BUILDUP;
    case 4:
    case "SHORT_COVERING":
      return Outlook.SHORT_COVERING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Outlook.UNRECOGNIZED;
  }
}

export function outlookToJSON(object: Outlook): string {
  switch (object) {
    case Outlook.OUTLOOK_UNKNOWN:
      return "OUTLOOK_UNKNOWN";
    case Outlook.LONG_BUILDUP:
      return "LONG_BUILDUP";
    case Outlook.LONG_UNWINDING:
      return "LONG_UNWINDING";
    case Outlook.SHORT_BUILDUP:
      return "SHORT_BUILDUP";
    case Outlook.SHORT_COVERING:
      return "SHORT_COVERING";
    case Outlook.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetOptionChainRequestV2 {
  security: Security | undefined;
  expiries: number[];
  noOfStrikes: number;
  requestedFields: OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum[];
  timeBucket: TimeBucket | undefined;
  sendFutures: boolean;
}

export interface OptionChainProto {
  security: Security | undefined;
  expiryOptionChain: ExpiryOptionChainProto[];
  expiryFuture: FutureProto[];
  referenceTimestamp: number;
  priceMultiplier: number;
  underlyingCurrentPrice: number;
  underlyingLastDayClosingPrice?: number | undefined;
}

export interface FutureProto {
  expiry: number;
  security: Security | undefined;
  futureCandle: OptionChainLineItemCandleProto | undefined;
  volumeFreezeQuantity: number;
  lotSize: number;
  tickSize: number;
}

export interface ExpiryOptionChainProto {
  /** NIFTY_50_14_NOV_ */
  expiry: number;
  securityCodePrefix: string;
  ivx: number;
  standardDeviation: number;
  pcr: number;
  atmStrike: number;
  atmIv: number;
  weekly: boolean;
  strikeOptionChainLineItem: OptionChainLineItemProto[];
  volumeFreezeQuantity: number;
  lotSize: number;
  tickSize: number;
}

export interface OptionChainLineItemProto {
  strikePrice: number;
  pcr: number;
  callCandle: OptionChainLineItemCandleProto | undefined;
  putCandle: OptionChainLineItemCandleProto | undefined;
}

export interface CandleChangeProto {
  timeBucket: TimeBucket | undefined;
  previousLtp?: number | undefined;
  currentLtp: number;
  previousOi?: number | undefined;
  currentOi: number;
}

export interface OptionChainLineItemCandleProto {
  topBid: number;
  topAsk: number;
  volume: number;
  openInterest: number;
  impliedVolatility: number;
  optionGreeks: OptionGreeks | undefined;
  candleChange: CandleChangeProto | undefined;
  spanMargin: number;
  exposureMargin: number;
}

export enum OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum {
  OPTION_CHAIN_LINE_ITEM_CANDLE_FIELD_UNSPECIFIED = 0,
  TOP_BID = 1,
  TOP_ASK = 2,
  VOLUME = 3,
  OPEN_INTEREST = 4,
  IMPLIED_VOLATILITY = 5,
  OPTION_GREEKS = 6,
  CANDLE_CHANGE = 7,
  UNRECOGNIZED = -1,
}

export function optionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnumFromJSON(
  object: any,
): OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum {
  switch (object) {
    case 0:
    case "OPTION_CHAIN_LINE_ITEM_CANDLE_FIELD_UNSPECIFIED":
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum
        .OPTION_CHAIN_LINE_ITEM_CANDLE_FIELD_UNSPECIFIED;
    case 1:
    case "TOP_BID":
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.TOP_BID;
    case 2:
    case "TOP_ASK":
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.TOP_ASK;
    case 3:
    case "VOLUME":
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.VOLUME;
    case 4:
    case "OPEN_INTEREST":
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.OPEN_INTEREST;
    case 5:
    case "IMPLIED_VOLATILITY":
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.IMPLIED_VOLATILITY;
    case 6:
    case "OPTION_GREEKS":
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.OPTION_GREEKS;
    case 7:
    case "CANDLE_CHANGE":
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.CANDLE_CHANGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.UNRECOGNIZED;
  }
}

export function optionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnumToJSON(
  object: OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum,
): string {
  switch (object) {
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum
      .OPTION_CHAIN_LINE_ITEM_CANDLE_FIELD_UNSPECIFIED:
      return "OPTION_CHAIN_LINE_ITEM_CANDLE_FIELD_UNSPECIFIED";
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.TOP_BID:
      return "TOP_BID";
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.TOP_ASK:
      return "TOP_ASK";
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.VOLUME:
      return "VOLUME";
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.OPEN_INTEREST:
      return "OPEN_INTEREST";
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.IMPLIED_VOLATILITY:
      return "IMPLIED_VOLATILITY";
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.OPTION_GREEKS:
      return "OPTION_GREEKS";
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.CANDLE_CHANGE:
      return "CANDLE_CHANGE";
    case OptionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface OptionExpiriesProto {
  security: Security | undefined;
  expiryStrikes: OptionExpiriesProto_ExpiryStrikesProto[];
}

export interface OptionExpiriesProto_ExpiryStrikesProto {
  expiry: Expiry | undefined;
  strikes: number[];
  derived: boolean;
  /** NIFTY_50_14_NOV_ */
  securityCodePrefix: string;
}

function createBaseGetOptionChainRequestV2(): GetOptionChainRequestV2 {
  return {
    security: undefined,
    expiries: [],
    noOfStrikes: 0,
    requestedFields: [],
    timeBucket: undefined,
    sendFutures: false,
  };
}

export const GetOptionChainRequestV2 = {
  encode(message: GetOptionChainRequestV2, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    writer.uint32(18).fork();
    for (const v of message.expiries) {
      writer.int64(v);
    }
    writer.ldelim();
    if (message.noOfStrikes !== 0) {
      writer.uint32(24).int32(message.noOfStrikes);
    }
    writer.uint32(34).fork();
    for (const v of message.requestedFields) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(42).fork()).ldelim();
    }
    if (message.sendFutures !== false) {
      writer.uint32(48).bool(message.sendFutures);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOptionChainRequestV2 {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOptionChainRequestV2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag === 16) {
            message.expiries.push(longToNumber(reader.int64() as Long));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.expiries.push(longToNumber(reader.int64() as Long));
            }

            continue;
          }

          break;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.noOfStrikes = reader.int32();
          continue;
        case 4:
          if (tag === 32) {
            message.requestedFields.push(reader.int32() as any);

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.requestedFields.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.sendFutures = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOptionChainRequestV2 {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      expiries: globalThis.Array.isArray(object?.expiries) ? object.expiries.map((e: any) => globalThis.Number(e)) : [],
      noOfStrikes: isSet(object.noOfStrikes) ? globalThis.Number(object.noOfStrikes) : 0,
      requestedFields: globalThis.Array.isArray(object?.requestedFields)
        ? object.requestedFields.map((e: any) =>
          optionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnumFromJSON(e)
        )
        : [],
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      sendFutures: isSet(object.sendFutures) ? globalThis.Boolean(object.sendFutures) : false,
    };
  },

  toJSON(message: GetOptionChainRequestV2): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.expiries?.length) {
      obj.expiries = message.expiries.map((e) => Math.round(e));
    }
    if (message.noOfStrikes !== 0) {
      obj.noOfStrikes = Math.round(message.noOfStrikes);
    }
    if (message.requestedFields?.length) {
      obj.requestedFields = message.requestedFields.map((e) =>
        optionChainLineItemCandleProto_OptionChainLineItemCandleFieldEnumToJSON(e)
      );
    }
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.sendFutures !== false) {
      obj.sendFutures = message.sendFutures;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOptionChainRequestV2>, I>>(base?: I): GetOptionChainRequestV2 {
    return GetOptionChainRequestV2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOptionChainRequestV2>, I>>(object: I): GetOptionChainRequestV2 {
    const message = createBaseGetOptionChainRequestV2();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.expiries = object.expiries?.map((e) => e) || [];
    message.noOfStrikes = object.noOfStrikes ?? 0;
    message.requestedFields = object.requestedFields?.map((e) => e) || [];
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.sendFutures = object.sendFutures ?? false;
    return message;
  },
};

function createBaseOptionChainProto(): OptionChainProto {
  return {
    security: undefined,
    expiryOptionChain: [],
    expiryFuture: [],
    referenceTimestamp: 0,
    priceMultiplier: 0,
    underlyingCurrentPrice: 0,
    underlyingLastDayClosingPrice: undefined,
  };
}

export const OptionChainProto = {
  encode(message: OptionChainProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.expiryOptionChain) {
      ExpiryOptionChainProto.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.expiryFuture) {
      FutureProto.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.referenceTimestamp !== 0) {
      writer.uint32(32).int64(message.referenceTimestamp);
    }
    if (message.priceMultiplier !== 0) {
      writer.uint32(48).int32(message.priceMultiplier);
    }
    if (message.underlyingCurrentPrice !== 0) {
      writer.uint32(56).int32(message.underlyingCurrentPrice);
    }
    if (message.underlyingLastDayClosingPrice !== undefined) {
      writer.uint32(64).int32(message.underlyingLastDayClosingPrice);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionChainProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionChainProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expiryOptionChain.push(ExpiryOptionChainProto.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.expiryFuture.push(FutureProto.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.referenceTimestamp = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.priceMultiplier = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.underlyingCurrentPrice = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.underlyingLastDayClosingPrice = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionChainProto {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      expiryOptionChain: globalThis.Array.isArray(object?.expiryOptionChain)
        ? object.expiryOptionChain.map((e: any) => ExpiryOptionChainProto.fromJSON(e))
        : [],
      expiryFuture: globalThis.Array.isArray(object?.expiryFuture)
        ? object.expiryFuture.map((e: any) => FutureProto.fromJSON(e))
        : [],
      referenceTimestamp: isSet(object.referenceTimestamp) ? globalThis.Number(object.referenceTimestamp) : 0,
      priceMultiplier: isSet(object.priceMultiplier) ? globalThis.Number(object.priceMultiplier) : 0,
      underlyingCurrentPrice: isSet(object.underlyingCurrentPrice)
        ? globalThis.Number(object.underlyingCurrentPrice)
        : 0,
      underlyingLastDayClosingPrice: isSet(object.underlyingLastDayClosingPrice)
        ? globalThis.Number(object.underlyingLastDayClosingPrice)
        : undefined,
    };
  },

  toJSON(message: OptionChainProto): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.expiryOptionChain?.length) {
      obj.expiryOptionChain = message.expiryOptionChain.map((e) => ExpiryOptionChainProto.toJSON(e));
    }
    if (message.expiryFuture?.length) {
      obj.expiryFuture = message.expiryFuture.map((e) => FutureProto.toJSON(e));
    }
    if (message.referenceTimestamp !== 0) {
      obj.referenceTimestamp = Math.round(message.referenceTimestamp);
    }
    if (message.priceMultiplier !== 0) {
      obj.priceMultiplier = Math.round(message.priceMultiplier);
    }
    if (message.underlyingCurrentPrice !== 0) {
      obj.underlyingCurrentPrice = Math.round(message.underlyingCurrentPrice);
    }
    if (message.underlyingLastDayClosingPrice !== undefined) {
      obj.underlyingLastDayClosingPrice = Math.round(message.underlyingLastDayClosingPrice);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionChainProto>, I>>(base?: I): OptionChainProto {
    return OptionChainProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionChainProto>, I>>(object: I): OptionChainProto {
    const message = createBaseOptionChainProto();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.expiryOptionChain = object.expiryOptionChain?.map((e) => ExpiryOptionChainProto.fromPartial(e)) || [];
    message.expiryFuture = object.expiryFuture?.map((e) => FutureProto.fromPartial(e)) || [];
    message.referenceTimestamp = object.referenceTimestamp ?? 0;
    message.priceMultiplier = object.priceMultiplier ?? 0;
    message.underlyingCurrentPrice = object.underlyingCurrentPrice ?? 0;
    message.underlyingLastDayClosingPrice = object.underlyingLastDayClosingPrice ?? undefined;
    return message;
  },
};

function createBaseFutureProto(): FutureProto {
  return { expiry: 0, security: undefined, futureCandle: undefined, volumeFreezeQuantity: 0, lotSize: 0, tickSize: 0 };
}

export const FutureProto = {
  encode(message: FutureProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.expiry !== 0) {
      writer.uint32(96).int64(message.expiry);
    }
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.futureCandle !== undefined) {
      OptionChainLineItemCandleProto.encode(message.futureCandle, writer.uint32(18).fork()).ldelim();
    }
    if (message.volumeFreezeQuantity !== 0) {
      writer.uint32(72).int32(message.volumeFreezeQuantity);
    }
    if (message.lotSize !== 0) {
      writer.uint32(80).int32(message.lotSize);
    }
    if (message.tickSize !== 0) {
      writer.uint32(88).int32(message.tickSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FutureProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFutureProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 12:
          if (tag !== 96) {
            break;
          }

          message.expiry = longToNumber(reader.int64() as Long);
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.futureCandle = OptionChainLineItemCandleProto.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.volumeFreezeQuantity = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.lotSize = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.tickSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FutureProto {
    return {
      expiry: isSet(object.expiry) ? globalThis.Number(object.expiry) : 0,
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      futureCandle: isSet(object.futureCandle)
        ? OptionChainLineItemCandleProto.fromJSON(object.futureCandle)
        : undefined,
      volumeFreezeQuantity: isSet(object.volumeFreezeQuantity) ? globalThis.Number(object.volumeFreezeQuantity) : 0,
      lotSize: isSet(object.lotSize) ? globalThis.Number(object.lotSize) : 0,
      tickSize: isSet(object.tickSize) ? globalThis.Number(object.tickSize) : 0,
    };
  },

  toJSON(message: FutureProto): unknown {
    const obj: any = {};
    if (message.expiry !== 0) {
      obj.expiry = Math.round(message.expiry);
    }
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.futureCandle !== undefined) {
      obj.futureCandle = OptionChainLineItemCandleProto.toJSON(message.futureCandle);
    }
    if (message.volumeFreezeQuantity !== 0) {
      obj.volumeFreezeQuantity = Math.round(message.volumeFreezeQuantity);
    }
    if (message.lotSize !== 0) {
      obj.lotSize = Math.round(message.lotSize);
    }
    if (message.tickSize !== 0) {
      obj.tickSize = Math.round(message.tickSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FutureProto>, I>>(base?: I): FutureProto {
    return FutureProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FutureProto>, I>>(object: I): FutureProto {
    const message = createBaseFutureProto();
    message.expiry = object.expiry ?? 0;
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.futureCandle = (object.futureCandle !== undefined && object.futureCandle !== null)
      ? OptionChainLineItemCandleProto.fromPartial(object.futureCandle)
      : undefined;
    message.volumeFreezeQuantity = object.volumeFreezeQuantity ?? 0;
    message.lotSize = object.lotSize ?? 0;
    message.tickSize = object.tickSize ?? 0;
    return message;
  },
};

function createBaseExpiryOptionChainProto(): ExpiryOptionChainProto {
  return {
    expiry: 0,
    securityCodePrefix: "",
    ivx: 0,
    standardDeviation: 0,
    pcr: 0,
    atmStrike: 0,
    atmIv: 0,
    weekly: false,
    strikeOptionChainLineItem: [],
    volumeFreezeQuantity: 0,
    lotSize: 0,
    tickSize: 0,
  };
}

export const ExpiryOptionChainProto = {
  encode(message: ExpiryOptionChainProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.expiry !== 0) {
      writer.uint32(96).int64(message.expiry);
    }
    if (message.securityCodePrefix !== "") {
      writer.uint32(10).string(message.securityCodePrefix);
    }
    if (message.ivx !== 0) {
      writer.uint32(21).float(message.ivx);
    }
    if (message.standardDeviation !== 0) {
      writer.uint32(29).float(message.standardDeviation);
    }
    if (message.pcr !== 0) {
      writer.uint32(37).float(message.pcr);
    }
    if (message.atmStrike !== 0) {
      writer.uint32(40).int32(message.atmStrike);
    }
    if (message.atmIv !== 0) {
      writer.uint32(53).float(message.atmIv);
    }
    if (message.weekly !== false) {
      writer.uint32(56).bool(message.weekly);
    }
    for (const v of message.strikeOptionChainLineItem) {
      OptionChainLineItemProto.encode(v!, writer.uint32(66).fork()).ldelim();
    }
    if (message.volumeFreezeQuantity !== 0) {
      writer.uint32(72).int32(message.volumeFreezeQuantity);
    }
    if (message.lotSize !== 0) {
      writer.uint32(80).int32(message.lotSize);
    }
    if (message.tickSize !== 0) {
      writer.uint32(88).int32(message.tickSize);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExpiryOptionChainProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExpiryOptionChainProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 12:
          if (tag !== 96) {
            break;
          }

          message.expiry = longToNumber(reader.int64() as Long);
          continue;
        case 1:
          if (tag !== 10) {
            break;
          }

          message.securityCodePrefix = reader.string();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.ivx = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.standardDeviation = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.pcr = reader.float();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.atmStrike = reader.int32();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.atmIv = reader.float();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.weekly = reader.bool();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.strikeOptionChainLineItem.push(OptionChainLineItemProto.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.volumeFreezeQuantity = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.lotSize = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.tickSize = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExpiryOptionChainProto {
    return {
      expiry: isSet(object.expiry) ? globalThis.Number(object.expiry) : 0,
      securityCodePrefix: isSet(object.securityCodePrefix) ? globalThis.String(object.securityCodePrefix) : "",
      ivx: isSet(object.ivx) ? globalThis.Number(object.ivx) : 0,
      standardDeviation: isSet(object.standardDeviation) ? globalThis.Number(object.standardDeviation) : 0,
      pcr: isSet(object.pcr) ? globalThis.Number(object.pcr) : 0,
      atmStrike: isSet(object.atmStrike) ? globalThis.Number(object.atmStrike) : 0,
      atmIv: isSet(object.atmIv) ? globalThis.Number(object.atmIv) : 0,
      weekly: isSet(object.weekly) ? globalThis.Boolean(object.weekly) : false,
      strikeOptionChainLineItem: globalThis.Array.isArray(object?.strikeOptionChainLineItem)
        ? object.strikeOptionChainLineItem.map((e: any) => OptionChainLineItemProto.fromJSON(e))
        : [],
      volumeFreezeQuantity: isSet(object.volumeFreezeQuantity) ? globalThis.Number(object.volumeFreezeQuantity) : 0,
      lotSize: isSet(object.lotSize) ? globalThis.Number(object.lotSize) : 0,
      tickSize: isSet(object.tickSize) ? globalThis.Number(object.tickSize) : 0,
    };
  },

  toJSON(message: ExpiryOptionChainProto): unknown {
    const obj: any = {};
    if (message.expiry !== 0) {
      obj.expiry = Math.round(message.expiry);
    }
    if (message.securityCodePrefix !== "") {
      obj.securityCodePrefix = message.securityCodePrefix;
    }
    if (message.ivx !== 0) {
      obj.ivx = message.ivx;
    }
    if (message.standardDeviation !== 0) {
      obj.standardDeviation = message.standardDeviation;
    }
    if (message.pcr !== 0) {
      obj.pcr = message.pcr;
    }
    if (message.atmStrike !== 0) {
      obj.atmStrike = Math.round(message.atmStrike);
    }
    if (message.atmIv !== 0) {
      obj.atmIv = message.atmIv;
    }
    if (message.weekly !== false) {
      obj.weekly = message.weekly;
    }
    if (message.strikeOptionChainLineItem?.length) {
      obj.strikeOptionChainLineItem = message.strikeOptionChainLineItem.map((e) => OptionChainLineItemProto.toJSON(e));
    }
    if (message.volumeFreezeQuantity !== 0) {
      obj.volumeFreezeQuantity = Math.round(message.volumeFreezeQuantity);
    }
    if (message.lotSize !== 0) {
      obj.lotSize = Math.round(message.lotSize);
    }
    if (message.tickSize !== 0) {
      obj.tickSize = Math.round(message.tickSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExpiryOptionChainProto>, I>>(base?: I): ExpiryOptionChainProto {
    return ExpiryOptionChainProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExpiryOptionChainProto>, I>>(object: I): ExpiryOptionChainProto {
    const message = createBaseExpiryOptionChainProto();
    message.expiry = object.expiry ?? 0;
    message.securityCodePrefix = object.securityCodePrefix ?? "";
    message.ivx = object.ivx ?? 0;
    message.standardDeviation = object.standardDeviation ?? 0;
    message.pcr = object.pcr ?? 0;
    message.atmStrike = object.atmStrike ?? 0;
    message.atmIv = object.atmIv ?? 0;
    message.weekly = object.weekly ?? false;
    message.strikeOptionChainLineItem =
      object.strikeOptionChainLineItem?.map((e) => OptionChainLineItemProto.fromPartial(e)) || [];
    message.volumeFreezeQuantity = object.volumeFreezeQuantity ?? 0;
    message.lotSize = object.lotSize ?? 0;
    message.tickSize = object.tickSize ?? 0;
    return message;
  },
};

function createBaseOptionChainLineItemProto(): OptionChainLineItemProto {
  return { strikePrice: 0, pcr: 0, callCandle: undefined, putCandle: undefined };
}

export const OptionChainLineItemProto = {
  encode(message: OptionChainLineItemProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.strikePrice !== 0) {
      writer.uint32(32).int32(message.strikePrice);
    }
    if (message.pcr !== 0) {
      writer.uint32(13).float(message.pcr);
    }
    if (message.callCandle !== undefined) {
      OptionChainLineItemCandleProto.encode(message.callCandle, writer.uint32(18).fork()).ldelim();
    }
    if (message.putCandle !== undefined) {
      OptionChainLineItemCandleProto.encode(message.putCandle, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionChainLineItemProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionChainLineItemProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 4:
          if (tag !== 32) {
            break;
          }

          message.strikePrice = reader.int32();
          continue;
        case 1:
          if (tag !== 13) {
            break;
          }

          message.pcr = reader.float();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.callCandle = OptionChainLineItemCandleProto.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.putCandle = OptionChainLineItemCandleProto.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionChainLineItemProto {
    return {
      strikePrice: isSet(object.strikePrice) ? globalThis.Number(object.strikePrice) : 0,
      pcr: isSet(object.pcr) ? globalThis.Number(object.pcr) : 0,
      callCandle: isSet(object.callCandle) ? OptionChainLineItemCandleProto.fromJSON(object.callCandle) : undefined,
      putCandle: isSet(object.putCandle) ? OptionChainLineItemCandleProto.fromJSON(object.putCandle) : undefined,
    };
  },

  toJSON(message: OptionChainLineItemProto): unknown {
    const obj: any = {};
    if (message.strikePrice !== 0) {
      obj.strikePrice = Math.round(message.strikePrice);
    }
    if (message.pcr !== 0) {
      obj.pcr = message.pcr;
    }
    if (message.callCandle !== undefined) {
      obj.callCandle = OptionChainLineItemCandleProto.toJSON(message.callCandle);
    }
    if (message.putCandle !== undefined) {
      obj.putCandle = OptionChainLineItemCandleProto.toJSON(message.putCandle);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionChainLineItemProto>, I>>(base?: I): OptionChainLineItemProto {
    return OptionChainLineItemProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionChainLineItemProto>, I>>(object: I): OptionChainLineItemProto {
    const message = createBaseOptionChainLineItemProto();
    message.strikePrice = object.strikePrice ?? 0;
    message.pcr = object.pcr ?? 0;
    message.callCandle = (object.callCandle !== undefined && object.callCandle !== null)
      ? OptionChainLineItemCandleProto.fromPartial(object.callCandle)
      : undefined;
    message.putCandle = (object.putCandle !== undefined && object.putCandle !== null)
      ? OptionChainLineItemCandleProto.fromPartial(object.putCandle)
      : undefined;
    return message;
  },
};

function createBaseCandleChangeProto(): CandleChangeProto {
  return { timeBucket: undefined, previousLtp: undefined, currentLtp: 0, previousOi: undefined, currentOi: 0 };
}

export const CandleChangeProto = {
  encode(message: CandleChangeProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeBucket !== undefined) {
      TimeBucket.encode(message.timeBucket, writer.uint32(10).fork()).ldelim();
    }
    if (message.previousLtp !== undefined) {
      writer.uint32(16).int32(message.previousLtp);
    }
    if (message.currentLtp !== 0) {
      writer.uint32(24).int32(message.currentLtp);
    }
    if (message.previousOi !== undefined) {
      writer.uint32(32).int32(message.previousOi);
    }
    if (message.currentOi !== 0) {
      writer.uint32(40).int32(message.currentOi);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CandleChangeProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCandleChangeProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timeBucket = TimeBucket.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.previousLtp = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.currentLtp = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.previousOi = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.currentOi = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CandleChangeProto {
    return {
      timeBucket: isSet(object.timeBucket) ? TimeBucket.fromJSON(object.timeBucket) : undefined,
      previousLtp: isSet(object.previousLtp) ? globalThis.Number(object.previousLtp) : undefined,
      currentLtp: isSet(object.currentLtp) ? globalThis.Number(object.currentLtp) : 0,
      previousOi: isSet(object.previousOi) ? globalThis.Number(object.previousOi) : undefined,
      currentOi: isSet(object.currentOi) ? globalThis.Number(object.currentOi) : 0,
    };
  },

  toJSON(message: CandleChangeProto): unknown {
    const obj: any = {};
    if (message.timeBucket !== undefined) {
      obj.timeBucket = TimeBucket.toJSON(message.timeBucket);
    }
    if (message.previousLtp !== undefined) {
      obj.previousLtp = Math.round(message.previousLtp);
    }
    if (message.currentLtp !== 0) {
      obj.currentLtp = Math.round(message.currentLtp);
    }
    if (message.previousOi !== undefined) {
      obj.previousOi = Math.round(message.previousOi);
    }
    if (message.currentOi !== 0) {
      obj.currentOi = Math.round(message.currentOi);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CandleChangeProto>, I>>(base?: I): CandleChangeProto {
    return CandleChangeProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CandleChangeProto>, I>>(object: I): CandleChangeProto {
    const message = createBaseCandleChangeProto();
    message.timeBucket = (object.timeBucket !== undefined && object.timeBucket !== null)
      ? TimeBucket.fromPartial(object.timeBucket)
      : undefined;
    message.previousLtp = object.previousLtp ?? undefined;
    message.currentLtp = object.currentLtp ?? 0;
    message.previousOi = object.previousOi ?? undefined;
    message.currentOi = object.currentOi ?? 0;
    return message;
  },
};

function createBaseOptionChainLineItemCandleProto(): OptionChainLineItemCandleProto {
  return {
    topBid: 0,
    topAsk: 0,
    volume: 0,
    openInterest: 0,
    impliedVolatility: 0,
    optionGreeks: undefined,
    candleChange: undefined,
    spanMargin: 0,
    exposureMargin: 0,
  };
}

export const OptionChainLineItemCandleProto = {
  encode(message: OptionChainLineItemCandleProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.topBid !== 0) {
      writer.uint32(8).int32(message.topBid);
    }
    if (message.topAsk !== 0) {
      writer.uint32(16).int32(message.topAsk);
    }
    if (message.volume !== 0) {
      writer.uint32(24).int64(message.volume);
    }
    if (message.openInterest !== 0) {
      writer.uint32(32).int32(message.openInterest);
    }
    if (message.impliedVolatility !== 0) {
      writer.uint32(45).float(message.impliedVolatility);
    }
    if (message.optionGreeks !== undefined) {
      OptionGreeks.encode(message.optionGreeks, writer.uint32(50).fork()).ldelim();
    }
    if (message.candleChange !== undefined) {
      CandleChangeProto.encode(message.candleChange, writer.uint32(58).fork()).ldelim();
    }
    if (message.spanMargin !== 0) {
      writer.uint32(69).float(message.spanMargin);
    }
    if (message.exposureMargin !== 0) {
      writer.uint32(77).float(message.exposureMargin);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionChainLineItemCandleProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionChainLineItemCandleProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.topBid = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.topAsk = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.volume = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.openInterest = reader.int32();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.impliedVolatility = reader.float();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.optionGreeks = OptionGreeks.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.candleChange = CandleChangeProto.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.spanMargin = reader.float();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.exposureMargin = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionChainLineItemCandleProto {
    return {
      topBid: isSet(object.topBid) ? globalThis.Number(object.topBid) : 0,
      topAsk: isSet(object.topAsk) ? globalThis.Number(object.topAsk) : 0,
      volume: isSet(object.volume) ? globalThis.Number(object.volume) : 0,
      openInterest: isSet(object.openInterest) ? globalThis.Number(object.openInterest) : 0,
      impliedVolatility: isSet(object.impliedVolatility) ? globalThis.Number(object.impliedVolatility) : 0,
      optionGreeks: isSet(object.optionGreeks) ? OptionGreeks.fromJSON(object.optionGreeks) : undefined,
      candleChange: isSet(object.candleChange) ? CandleChangeProto.fromJSON(object.candleChange) : undefined,
      spanMargin: isSet(object.spanMargin) ? globalThis.Number(object.spanMargin) : 0,
      exposureMargin: isSet(object.exposureMargin) ? globalThis.Number(object.exposureMargin) : 0,
    };
  },

  toJSON(message: OptionChainLineItemCandleProto): unknown {
    const obj: any = {};
    if (message.topBid !== 0) {
      obj.topBid = Math.round(message.topBid);
    }
    if (message.topAsk !== 0) {
      obj.topAsk = Math.round(message.topAsk);
    }
    if (message.volume !== 0) {
      obj.volume = Math.round(message.volume);
    }
    if (message.openInterest !== 0) {
      obj.openInterest = Math.round(message.openInterest);
    }
    if (message.impliedVolatility !== 0) {
      obj.impliedVolatility = message.impliedVolatility;
    }
    if (message.optionGreeks !== undefined) {
      obj.optionGreeks = OptionGreeks.toJSON(message.optionGreeks);
    }
    if (message.candleChange !== undefined) {
      obj.candleChange = CandleChangeProto.toJSON(message.candleChange);
    }
    if (message.spanMargin !== 0) {
      obj.spanMargin = message.spanMargin;
    }
    if (message.exposureMargin !== 0) {
      obj.exposureMargin = message.exposureMargin;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionChainLineItemCandleProto>, I>>(base?: I): OptionChainLineItemCandleProto {
    return OptionChainLineItemCandleProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionChainLineItemCandleProto>, I>>(
    object: I,
  ): OptionChainLineItemCandleProto {
    const message = createBaseOptionChainLineItemCandleProto();
    message.topBid = object.topBid ?? 0;
    message.topAsk = object.topAsk ?? 0;
    message.volume = object.volume ?? 0;
    message.openInterest = object.openInterest ?? 0;
    message.impliedVolatility = object.impliedVolatility ?? 0;
    message.optionGreeks = (object.optionGreeks !== undefined && object.optionGreeks !== null)
      ? OptionGreeks.fromPartial(object.optionGreeks)
      : undefined;
    message.candleChange = (object.candleChange !== undefined && object.candleChange !== null)
      ? CandleChangeProto.fromPartial(object.candleChange)
      : undefined;
    message.spanMargin = object.spanMargin ?? 0;
    message.exposureMargin = object.exposureMargin ?? 0;
    return message;
  },
};

function createBaseOptionExpiriesProto(): OptionExpiriesProto {
  return { security: undefined, expiryStrikes: [] };
}

export const OptionExpiriesProto = {
  encode(message: OptionExpiriesProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.expiryStrikes) {
      OptionExpiriesProto_ExpiryStrikesProto.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionExpiriesProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionExpiriesProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expiryStrikes.push(OptionExpiriesProto_ExpiryStrikesProto.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionExpiriesProto {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      expiryStrikes: globalThis.Array.isArray(object?.expiryStrikes)
        ? object.expiryStrikes.map((e: any) => OptionExpiriesProto_ExpiryStrikesProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OptionExpiriesProto): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.expiryStrikes?.length) {
      obj.expiryStrikes = message.expiryStrikes.map((e) => OptionExpiriesProto_ExpiryStrikesProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionExpiriesProto>, I>>(base?: I): OptionExpiriesProto {
    return OptionExpiriesProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionExpiriesProto>, I>>(object: I): OptionExpiriesProto {
    const message = createBaseOptionExpiriesProto();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.expiryStrikes = object.expiryStrikes?.map((e) => OptionExpiriesProto_ExpiryStrikesProto.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseOptionExpiriesProto_ExpiryStrikesProto(): OptionExpiriesProto_ExpiryStrikesProto {
  return { expiry: undefined, strikes: [], derived: false, securityCodePrefix: "" };
}

export const OptionExpiriesProto_ExpiryStrikesProto = {
  encode(message: OptionExpiriesProto_ExpiryStrikesProto, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.expiry !== undefined) {
      Expiry.encode(message.expiry, writer.uint32(10).fork()).ldelim();
    }
    writer.uint32(18).fork();
    for (const v of message.strikes) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.derived !== false) {
      writer.uint32(24).bool(message.derived);
    }
    if (message.securityCodePrefix !== "") {
      writer.uint32(34).string(message.securityCodePrefix);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): OptionExpiriesProto_ExpiryStrikesProto {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOptionExpiriesProto_ExpiryStrikesProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.expiry = Expiry.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag === 16) {
            message.strikes.push(reader.int32());

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.strikes.push(reader.int32());
            }

            continue;
          }

          break;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.derived = reader.bool();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.securityCodePrefix = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OptionExpiriesProto_ExpiryStrikesProto {
    return {
      expiry: isSet(object.expiry) ? Expiry.fromJSON(object.expiry) : undefined,
      strikes: globalThis.Array.isArray(object?.strikes) ? object.strikes.map((e: any) => globalThis.Number(e)) : [],
      derived: isSet(object.derived) ? globalThis.Boolean(object.derived) : false,
      securityCodePrefix: isSet(object.securityCodePrefix) ? globalThis.String(object.securityCodePrefix) : "",
    };
  },

  toJSON(message: OptionExpiriesProto_ExpiryStrikesProto): unknown {
    const obj: any = {};
    if (message.expiry !== undefined) {
      obj.expiry = Expiry.toJSON(message.expiry);
    }
    if (message.strikes?.length) {
      obj.strikes = message.strikes.map((e) => Math.round(e));
    }
    if (message.derived !== false) {
      obj.derived = message.derived;
    }
    if (message.securityCodePrefix !== "") {
      obj.securityCodePrefix = message.securityCodePrefix;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OptionExpiriesProto_ExpiryStrikesProto>, I>>(
    base?: I,
  ): OptionExpiriesProto_ExpiryStrikesProto {
    return OptionExpiriesProto_ExpiryStrikesProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OptionExpiriesProto_ExpiryStrikesProto>, I>>(
    object: I,
  ): OptionExpiriesProto_ExpiryStrikesProto {
    const message = createBaseOptionExpiriesProto_ExpiryStrikesProto();
    message.expiry = (object.expiry !== undefined && object.expiry !== null)
      ? Expiry.fromPartial(object.expiry)
      : undefined;
    message.strikes = object.strikes?.map((e) => e) || [];
    message.derived = object.derived ?? false;
    message.securityCodePrefix = object.securityCodePrefix ?? "";
    return message;
  },
};

export interface OptionService {
  GetOptionChainV2(request: GetOptionChainRequestV2): Promise<OptionChainProto>;
}

export const OptionServiceServiceName = "com.tick2trade.api.candledatadepot.optionchain.OptionService";
export class OptionServiceClientImpl implements OptionService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || OptionServiceServiceName;
    this.rpc = rpc;
    this.GetOptionChainV2 = this.GetOptionChainV2.bind(this);
  }
  GetOptionChainV2(request: GetOptionChainRequestV2): Promise<OptionChainProto> {
    const data = GetOptionChainRequestV2.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetOptionChainV2", data);
    return promise.then((data) => OptionChainProto.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
